export default {
  allMsg: 'Todas as mensagens',
  systemMsg: 'Mensagem do sistema',
  personMsg: 'Mensagem pessoal',
  unread: 'Não lido',
  seeDetail: 'Ver detalhes',
  read: 'Lido',
  replyNow: 'Responder agora',
  message: 'Mensagem interna',
  operateSuccess: 'Operação bem-sucedida',
  holder: {
    searchHolder: 'Número do pacote/Número do pedido/Número do produto',
  },
  addAcBuy: 'Junte-se ao AcBuy Discord e ganhe prêmio em dinheiro de ¥2000!',
  flatActivity: '🎄 Ofertas Imperdíveis de Natal',
  joinNow1: 'Compre Agora',
  tips1: '🎁 Aproveite Descontos de Até 80 %',
  tips2: '🎅 Promoções de Fim de Ano por Tempo Limitado!',
}
